import { PATCH } from "../APiHelper/API"
let source;
export const setConfirmedAttendance = (data, onSuccess, onError) => {

    source = PATCH(`/api/v1/games/attendance`, data, onSuccess, onError, true, source)
}

